import { when } from 'mobx';
import { BaseSessionCtrl } from './base-session.controller';
import { getEnvType, EnvTypes } from '~/utils/environment.utils';
import { GlobalMXContextValue } from '~/providers/mx-global-context/global-mx.context';
import { saveUserToLocalStorage } from '~/common/user-storage.utils';

export class SessionCtrl extends BaseSessionCtrl {
    globalContext: GlobalMXContextValue;

    constructor(globalContext: GlobalMXContextValue, appBasePath: string) {
        super(globalContext, appBasePath);

        this.globalContext = globalContext;

        when(
            () => !!this.globalContext.configStore?.config?.hb_base_error_codes,
            () => this.printVersion()
        );
    }

    async login(email: string, password: string) {
        const user = await this.globalContext.sessionService.login({
            email,
            password
        });
        this.localLogin(user);
    }

    async forceFetchUser() {
        const currUser = this.globalContext.userStore.currUser;
        const user = await this.globalContext.userService.getUser(currUser._id);
        this.localLogin(user, true);

        return this.globalContext.userStore.currUser;
    }

    async proLogoutAsMember() {
        const { sessionService, jStorageService } = this.globalContext;
        const userResponse = await sessionService.proLogoutAsMember();
        saveUserToLocalStorage({
            user: userResponse,
            jStorageService
        });
        //TODO (REACT_FIRST): check if this is needed
        // analyticsService.unidentify();
        // analyticsService.identifyUser(
        //     new User(userResponse, this.globalContext)
        // );
        // analyticsService.track('client onsite logout');

        this.localLogin(userResponse, true);
    }

    printVersion = async () => {
        if (process.env.NODE_ENV === 'test') {
            return;
        }

        const envType = getEnvType();

        if (envType === EnvTypes.Staging) {
            const response =
                await this.globalContext.sessionService.getReactVersion();
            const version = response === 'production' ? 'master' : response;

            // eslint-disable-next-line no-console
            console.debug(
                `####################  React App Version: ${version}  ####################`
            );
            return;
        }

        // eslint-disable-next-line no-console
        console.debug(
            `####################  React App Version: ${envType}  ####################`
        );
    };
}
